<template>
  <div class="upload-container">
    <el-button icon='el-icon-upload'
               size="mini"
               :style="{background:color,borderColor:color}"
               @click=" dialogVisible=true"
               type="primary">上传图片
    </el-button>
    <el-dialog append-to-body
               :visible.sync="dialogVisible">
      <el-upload class="editor-slide-upload"
                 :action="dataObj.host"
                 :data="dataObj"
                 :multiple="true"
                 :file-list="fileList"
                 :show-file-list="true"
                 list-type="picture-card"
                 :on-remove="handleRemove"
                 :on-success="handleSuccess"
                 :before-upload="beforeUpload">
        <el-button size="small"
                   type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit">确 定</el-button>
    </el-dialog>
    <el-button size="mini"
               @click="addPhoto">图片库选择
    </el-button>
    <!-- 选择图片 -->
    <add-photo-modal :modal="modal"
                     @handlePhoto="handlePhoto"></add-photo-modal>
  </div>
</template>

<script>
import { policy } from '@/api/oss'
import { AddPhotoModal } from '@/views/pms/components'
import md5 from 'js-md5'

export default {
  name: 'editorSlideUpload',
  components: {
    AddPhotoModal
  },
  props: {
    color: {
      type: String,
      default: '#1890ff'
    },
    mchtId: {
      type: Number
    }
  },
  data () {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: [],
      dataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: 'https://haihaigo.oss-cn-shenzhen.aliyuncs.com'
      },
      modal: {
        addPhotoVisible: false,
        flag: 10, // 数量限制
      },
    }
  },
  methods: {
    checkAllSuccess () {
      return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
    },
    handleSubmit () {
      const arr = Object.keys(this.listObj).map(v => this.listObj[v])
      if (!this.checkAllSuccess()) {
        this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return
      }
      this.$emit('successCBK', arr)
      this.listObj = {}
      this.fileList = []
      this.dialogVisible = false
    },
    // 添加图片库图片
    addPhoto () {
      this.modal = {
        addPhotoVisible: true,
        flag: 10, // 数量限制
        mchtId: this.mchtId
      }
    },
    // 图片弹窗
    handlePhoto (value) {
      const photos = []
      for (var i of value) {
        photos.push({
          url: i
        })
      }
      this.$emit('successCBK', photos)
      this.modal.addPhotoVisible = false
    },
    handleSuccess (response, file) {
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = this.dataObj.host + '/' + this.dataObj.dir + '/' + file.uid + md5(file.name)
          this.listObj[objKeyArr[i]].hasSuccess = true
          return
        }
      }
    },
    handleRemove (file) {
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]]
          return
        }
      }
    },
    beforeUpload (file) {
      let _self = this
      // 最大只能上传2M文件
      if (file.size > 2097152) {
        this.$message.error('上传失败，最大只能上传2M大小的图片')
        return false
      }
      this.listObj[file.uid] = {}
      return new Promise((resolve, reject) => {
        policy().then(response => {
          _self.dataObj.policy = response.data.policy
          _self.dataObj.signature = response.data.signature
          _self.dataObj.ossaccessKeyId = response.data.accessKeyId
          _self.dataObj.key = response.data.dir + '/' + file.uid + md5(file.name)
          _self.dataObj.dir = response.data.dir
          _self.dataObj.host = response.data.host
          _self.listObj[file.uid] = { hasSuccess: false, uid: file.uid, width: this.width, height: this.height }
          resolve(true)
        }).catch(err => {
          console.log(err)
          reject(false)
        })
      })
    }
  }
}
</script>

<style>
.editor-slide-upload .el-upload {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tinymce/components/editorImage.vue